export const EMAIL_NOTIFICATION_OPTION = {
	YES: true,
	NO: false
}

export const LIVING_IN_LAVAL = {
	YES: true,
	NO: false
}
